const initialState = {
    showModal: false,
    isAppointed: false
};

export default function FormReducer(state=initialState, action) {
    switch (action.type) {
        case 'SHOW_FORM' : {
            return {
                date: action.payload.date,
                time: action.payload.time,
                showModal: true
            };
        }
        case 'APPOINTMENT_OK' : {
            return {
                date: action.payload.date,
                time: action.payload.time,
                ticketCount: action.payload.ticketCount,
                ruDay: action.payload.ruDay,
                showModal: false,
                isAppointed: true
            };
        }
        case 'APPOINTMENT_FAIL' : {
            return {
                showModal: false,
                isAppointed: false,
                hasError: true,
                message: action.payload.msg
            };
        }
        case 'APPOINTMENT_CLOSE' : {
            return {
                showModal: false,
                isAppointed: false
            };
        }
        case 'HIDE_FORM' : {
            return { showModal: false };
        }
        default: return state;
    }
}



// WEBPACK FOOTER //
// frontend/src/reducers/FormReducer.js